/**
 * IndexedDB storage for offline-first technician app.
 * Uses Dexie.js as a lightweight wrapper over IndexedDB.
 *
 * Tables:
 *   syncQueue    — pending operations waiting to be synced to server
 *   cachedJobs   — full job data cache (replaces localStorage fsa_wo_*)
 *   cachedPhotos — photo blobs that couldn't be uploaded while offline
 *   formDrafts   — auto-saved form data (notes, checklist, work report, etc.)
 *   syncMeta     — metadata: last sync time, queue stats, etc.
 *   errorLogs    — frontend error buffer (synced to backend DB when online)
 */
import Dexie from 'dexie'

const db = new Dexie('TechVillOffline')

db.version(2).stores({
  syncQueue:    '++id, type, status, createdAt, priority, idempotencyKey',
  cachedJobs:   'jobId, updatedAt',
  cachedPhotos: '++id, jobId, createdAt',
  formDrafts:   '[entityType+entityId], updatedAt',
  syncMeta:     'key',
  errorLogs:    '++id, synced, createdAt',
})

export default db
